export default __webpack_public_path__ + "static/media/resolução-anuidade-2016.c2a9611e.docx";